import {inputBaseClasses, styled, TextField} from "@mui/material";

const CustomSelect = styled(TextField)(({theme}) => ({
    [`& .${inputBaseClasses.root}`]: {
        backgroundColor: theme.palette.background.box,
        borderRadius: 8,
        boxShadow: "0px 0px 12px -1px rgba(33, 33, 33, 0.15)",
    },
    [`& .${inputBaseClasses.input}`]: {
        fontSize: ".855rem"
    }
}));
CustomSelect.defaultProps = {
    variant: "filled",
    select: true,
    fullWidth: true,
    InputProps: {disableUnderline: true}
}
export default CustomSelect;